export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'left',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('INDEX.replenishment_label_goodsName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'left',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: {
      default: 'displayName'
    }
  },
  {
    title: that.$l('INDEX.table_label_salesTitle') || '售卖标题',
    field: 'salesTitle',
    minWidth: 380,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesTitle' }
  },
  {
    title: that.$l('form_label_storeInfo') || '店铺信息',
    field: 'storeInfo',
    headerAlign: 'left',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    slots: {
      default: 'storeInfo'
    }
  },
  {
    title: that.$l('INDEX.amz_sku_inv_scmName') || '工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' }
  },
  {
    title: that.$l('form_label_shipmentInfo') || '发运明细',
    field: 'shipmentInfo',
    headerAlign: 'left',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    slots: {
      default: 'shipmentInfo'
    }
  },

]
